module.exports = __webpack_public_path__ + "8f20a58809e75de0515a710db3a846fa.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_medium_x1/public/games/coh_image_3.png
// module id = 486
// module chunks = 0